// extracted by mini-css-extract-plugin
module.exports = {"list":"InfoList__list--3hQ","item":"InfoList__item--3BU"};